import { AppAction, Application } from '../../apis/eols-app-link/eols-app-link.constants';
import { RoutePath } from '../../components/app/app.constants';
import { CatalogPageTitleClickProps } from '../../models/assignment-types-shared.models';
import { stripNilProps } from '../../utilities/common.utilities';
import { ApplicationNavigateHandlerMapProps, AssignmentTypeStrategy, CoursePlanPerformanceReportClickProps, CoursePlanTitleClickProps } from '../model';
import { navigateExternal } from '../utils/common.utils';

const navigateToHESI = (props: CoursePlanTitleClickProps | CoursePlanPerformanceReportClickProps) => {
  const { defArgs, sharedAppLinkParams } = props;
  const { navigateToApp } = defArgs.props;
  return Promise.resolve(
    navigateToApp({
      app: Application.HESI_NG,
      action: AppAction.LAUNCH,
      includeLinkHash: true,
      body: sharedAppLinkParams
    })
  );
};

export const hesiAssess: AssignmentTypeStrategy = {
  coursePlanTitleClick: navigateToHESI,
  coursePlanPerformanceReportClick: navigateToHESI,
  catalogPageTitleClick: (props: CatalogPageTitleClickProps) => {
    const { defArgs, contentItem } = props;
    const { navigateToApp, courseSectionId } = defArgs.props;
    navigateToApp({
      app: Application.HESI_NG,
      action: AppAction.LAUNCH,
      includeLinkHash: true,
      body: stripNilProps({
        catalogItem: contentItem,
        ref: RoutePath.CATALOG,
        courseSectionId
      })
    });
  },
  assignmentOverviewTitleClick: (props: ApplicationNavigateHandlerMapProps) =>
    navigateExternal({
      ...props,
      appLinkConfig: { ...props.appLinkConfig, action: AppAction.LAUNCH }
    }),
  assignmentOverviewPerformanceReportClick: (
    props: ApplicationNavigateHandlerMapProps
  ) =>
    navigateExternal({
      ...props,
      appLinkConfig: { ...props.appLinkConfig, action: AppAction.LAUNCH }
    }),
  navigateToAppForAssignmentPerformanceHandlerMap: () => Application.HESI_NG,
  navigateToAppHandlerMap: () => Application.HESI_NG,
};
